/******/ (() => { // webpackBootstrap
var __webpack_exports__ = {};
Shopify.theme.jsMegaMenu = {
  init: function($section) {
    // Add settings from schema to current object
    Shopify.theme.jsMegaMenu = $.extend(this, Shopify.theme.getSectionData($section));

    // Selectors
    const parentLink = this.parent_link;
    const sectionId = this.section_id;
    const $megaMenu = $section.find('.mega-menu__' + sectionId);
    const $parentElement = $('.header__menu [data-navlink-handle="' + parentLink + '"], .sticky-header__menu [data-navlink-handle="' + parentLink + '"]');
    const $parentElementLink = $parentElement.children('.header__link');
    // Remove old mega menus
    $parentElement.find('.mega-menu__section').remove();

    // Mobile Selectors
    const $parentMobileElement = $(`[data-mobile-menu-navlink-handle="${parentLink}"]`);

    /* No submenu is present - add mega menu elements and caret */
    if ($parentMobileElement.find('.has-no-submenu').length) {

      // Assign class to display dropdown arrow
      $parentMobileElement.find('a.mobile-menu__item').addClass('mobile-menu-link');

      // Insert close icon after menu item
      $parentMobileElement.find('a').after('<span class="close-dropdown" aria-expanded="false"></span>');

      // Insert placeholder ul for megamenu
      $parentMobileElement.find('.submenu__label').after('<ul class="mobile-submenu__list mobile-menu__submenu has-mega-menu" data-mobile-submenu-first-level-list></ul>')

      // Find data attribute for toggle and assign it true
      let $mobileMenuToggle = $parentMobileElement.find('[data-mobile-menu-has-toggle]');
      $($mobileMenuToggle).attr('data-mobile-menu-has-toggle', true);


      // Insert mega menu
      let $parentList = $parentMobileElement.find('.has-mega-menu');
      $megaMenu.clone().appendTo($parentList);

    } else {
      /* Submenu is present - add mega menu elements and remove current sub-menu */
      let $parentList = $parentMobileElement.find('[data-mobile-submenu-first-level-list]');

      $parentList
        .empty()
        .addClass('has-mega-menu')
        .removeClass('has-dropdown');

      // Insert mega menu
      $megaMenu.clone().appendTo($parentList);
    }


    // Desktop
    if ($parentElement.hasClass('header__item') || $parentElement.hasClass('vertical-header__first-level')) {
      // Hide default dropdown
      $parentElement.find('.navbar-dropdown').addClass('is-invisible is-hidden');

      // Add arrow to parent link to indicate dropdown
      $parentElementLink.removeClass('is-arrowless');

      $megaMenu.clone().appendTo('.vertical-header__first-level[data-navlink-handle="' + parentLink + '"], .header__item[data-navlink-handle="' + parentLink + '"]');

      // Add/remove classes for proper styling and append mega menu instance
      $parentElement.addClass('has-mega-menu')
    }

    // Determine if header is set to hover to open or click to open
    if ($('.dropdown-click--false').length > 0) {
      $('.navbar-item, .header__brand, .header__search').on('mouseover', function(){

        //Close any mega menus on hover
        $('.mega-menu__section').removeClass('is-active');
        // $('html').removeClass('megamenu--active');

        if($(this).hasClass('has-mega-menu')) {

          //Toggle corresponding mega menu
          $(this).find('.mega-menu__section').addClass('is-active');
          // $('html').addClass('megamenu--active');
        }
      })

      $('.mega-menu__section, .navbar').on('mouseleave', function(){

        //Hide mega menu upon leaving mega menu, logo or navbar
        $('.mega-menu__section').removeClass('is-active');
        // $('html').removeClass('megamenu--active');
      })
    } else {
      $('.navbar-item, .header__brand, .header__search').on('click touchstart', function(){

        //Close any mega menus on click
        $('.mega-menu__section').removeClass('is-active');

        if($(this).hasClass('has-mega-menu')) {

          //Toggle corresponding mega menu
          $(this).find('.mega-menu__section').addClass('is-active');
        }
      })
    }

    // Custom Mega Menu JS Start
    function initMegaMenu() {
      if (window.innerWidth >= 799) {
        let lastActive = null;
    
        $(".menu__heading").on("mouseenter", function () {
          let headingClass = $(this).attr("class").match(/menu-heading-\d+/)[0];
    
          $(".menu__heading, .mega-menu__linklist").removeClass("active");
          $(".mega-menu__sub-linklist").removeClass("active");
    
          $(this).addClass("active");
          $('.mega-menu__linklist[data-menu="' + headingClass + '"]').addClass("active");
    
          lastActive = $(this);
        });
    
        $(".mega-menu__linklist").on("mouseenter", "a[data-parent]", function () {
          const parentKey = $(this).data("parent");
          $(".mega-menu__sub-linklist").removeClass("active");
          $('ul.mega-menu__sub-linklist[data-parent="' + parentKey + '"]').addClass("active");
        });
    
        $(".mega-menu").on("mouseleave", function () {
          if (lastActive) {
            let headingClass = lastActive.attr("class").match(/menu-heading-\d+/)[0];
    
            $(".menu__heading, .mega-menu__linklist").removeClass("active");
            $(".mega-menu__sub-linklist").removeClass("active");
    
            lastActive.addClass("active");
            $('.mega-menu__linklist[data-menu="' + headingClass + '"]').addClass("active");
          }
        });
      }
    }
    $(document).ready(initMegaMenu);
    $(window).on("resize", function () {
      if (window.innerWidth === 798) {
        $(".menu__heading, .mega-menu__linklist").off();
        initMegaMenu();
      }
    });
    // For Desktop

    function initMobileMegaMenu() {
      if (window.innerWidth < 799) {
        let lastActive = null;
    
        $(".menu__heading > a").off("click").on("click", function (e) {
          const $heading = $(this).closest(".menu__heading");
          const headingClassMatch = $heading.attr("class").match(/menu-heading-\d+/);
          
          if (!headingClassMatch) return;
    
          const headingClass = headingClassMatch[0];
    
          // Prevent default redirect on first click
          if (!$heading.hasClass("active")) {
            e.preventDefault();
    
            // Remove previous actives
            $(".menu__heading, .mega-menu__linklist").removeClass("active");
            $(".mega-menu__sub-linklist").removeClass("active");
    
            // Add active to clicked one
            $heading.addClass("active");
            $('.mega-menu__linklist[data-menu="' + headingClass + '"]').addClass("active");
    
            lastActive = $heading;
          }
          // else allow default anchor behavior (redirect)
        });
    
        $(".mega-menu__linklist").off("click").on("click", "a[data-parent]", function (e) {
          const parentKey = $(this).data("parent");
          $(".mega-menu__sub-linklist").removeClass("active");
          $('ul.mega-menu__sub-linklist[data-parent="' + parentKey + '"]').addClass("active");
        });
    
        $(".mega-menu").off("mouseleave"); // Remove hover-specific listeners
      }
    }
    function handleMenuInit() {
      if (window.innerWidth >= 799) {
        initMegaMenu();
      } else {
        initMobileMegaMenu();
      }
    }
    $(document).ready(handleMenuInit);
    $(window).on("resize", function () {
      handleMenuInit();
    });
    // For Mobile

    $(document).on('click', '.back-btn', function() {
      var labelText = $(this)
      .parent()
      .parent()
      .parent()
      .parent()
      .parent()
      .parent()
      .find('.mobile-menu-link')
      .text()
      .trim()
      .toLowerCase();
      var formattedText = labelText.replace(/\s+/g, '-'); 
      var submenuInput = $('#mobile-submenu-' + formattedText);
      if (submenuInput.length && submenuInput.prop('checked')) {
        submenuInput.prop('checked', false).trigger('change');
      }
    });
    // Custom Mega Menu JS End
  },
  showThemeEditorState: function(id, $section) {
    $('.mega-menu__' + id + ' .mega-menu').addClass('mega-menu--force-show');
    $('.mega-menu__' + id + ' .mega-menu').prev('.header__link').addClass('is-active');
  },
  hideThemeEditorState: function(id, $section) {
    $('.mega-menu__' + id + ' .mega-menu').removeClass('mega-menu--force-show');
    $('.mega-menu__' + id + ' .mega-menu').prev('.header__link').removeClass('is-active');
  },
  displayMenu: function(id) {
    $('.mega-menu').removeClass('mega-menu--show');
    $('.mega-menu__' + id + ' .mega-menu').addClass('mega-menu--show');
  },
  hideMenu: function(id) {
    $('.mega-menu__' + id + ' .mega-menu').removeClass('mega-menu--show');
  },
  unload: function($section) {
    let parentLink = $section.find('.mega-menu').data('parent-link');
    let navLink = $('[data-navlink-handle="' + parentLink + '"]')
    navLink.off();
    navLink.find('.mega-menu__section').remove();
    $('.mega-menu__section, .navbar, .navbar-item, .header__brand, .header__search').off();
  }
}

/******/ })()
;